<div class="mat-elevation-z8 document-comp">
    <div>
        <button matTooltip="{{this.translate.data['DOCUMENTADDBUTTONTOOLTIP'] | translate}}" mat-raised-button
            (click)="openDocumentAddDialog(docStereoTypeId)">
            <mat-icon>add</mat-icon>
        </button>
    </div>
    <div>
        <div>
            <ag-grid-angular style="width:100%; height:100%; padding: 10px;" class="ag-theme-balham"
                [gridOptions]="gridOptions" (gridReady)="onGridReady($event)" (rowClicked)="onRowClicked($event)"
                (rowSelected)="onRowSelected($event)" [frameworkComponents]="frameworkComponents">
            </ag-grid-angular>
        </div>
        <div>
            <edit-document *ngIf="valueConfPageDtos !== undefined && valueConfPageDtos?.length !== 0"
                [valueConfPageDtos]="valueConfPageDtos" [documentDto]="documentDto" [controlData]="controlData"
                [cntData]="cntData" [documentStatus]="documentStatus" [documentName]="documentName">
            </edit-document>
        </div>
    </div>
</div>
